// Animazioni Scroll per Azienda Agricola Moretti
document.addEventListener('DOMContentLoaded', function() {
  
  // Funzione per rilevare quando un elemento entra nella viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // Funzione per animare gli elementi
  function animateOnScroll() {
    const elements = document.querySelectorAll('.animate-on-scroll');
    
    elements.forEach(function(element) {
      if (isInViewport(element)) {
        element.classList.add('animated');
      }
    });
  }

  // Esegui al caricamento e allo scroll
  animateOnScroll();
  window.addEventListener('scroll', animateOnScroll);

  // Animazioni hover per card prodotto
  const productCards = document.querySelectorAll('.card-wrapper, .product-card, .card');
  
  productCards.forEach(function(card) {
    card.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-8px)';
      this.style.transition = 'all 0.3s ease';
    });
    
    card.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
    });
  });

  // Smooth scroll per link interni
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && document.querySelector(href)) {
        e.preventDefault();
        document.querySelector(href).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

});
